import React from "react";
import Dropdown, { DropdownOption } from "./Dropdown";

export type SortMode = 'recent' | 'name' | 'collection';

interface SortOption {
  value: SortMode;
  label: string;
}

const sortOptions: SortOption[] = [
  { value: "recent", label: "Recent" },
  { value: "name", label: "Name" },
  { value: "collection", label: "Collection" },
];

interface SortDropdownProps {
  sortMode: SortMode;
  onSortModeSelect: (mode: SortMode) => void;
  className?: string;
}

const SortDropdown: React.FC<SortDropdownProps> = ({ sortMode, onSortModeSelect, className }) => {
  const selectedOption = sortOptions.find(option => option.value === sortMode);

  return (
    <Dropdown label="Sort:" selectedLabel={selectedOption?.label ?? 'Select'} className={className}>
      {({ close }) => sortOptions.map(({value, label}) => (
        <DropdownOption key={value} onClick={() => { onSortModeSelect(value); close(); }}>
          <div className="text-sm text-gray-900">{label}</div>
        </DropdownOption>
      ))}
    </Dropdown>
  )
};

export default SortDropdown;
